import { useListView } from '../../core/ListViewProvider'
import { ExameClienteListGrouping } from './ExameClienteListGrouping'
import { ExameClienteListSearchComponent } from './ExameClienteListSearchComponent'
import { ExameClienteListToolbar } from './ExameClienteListToolbar'

export const ExameClienteListHeader = () => {
  const { selected } = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <ExameClienteListSearchComponent
        actions={selected.length > 0 ? <ExameClienteListGrouping /> : <ExameClienteListToolbar />}
      />
    </div>
  )
}
